export const dateFormat = 'YYYY-MM-DD hh:mm:ss.SSSS'
export const dateFormatAvs = [
  'YYYY-MM-DD',
  'YYYY-MM-DD hh:mm:ss',
  'YYYY-MM-DD hh:mm:ss.SSSS',
]
export const dateFormatRegex =
  /^\d{4}-\d{2}-\d{2}( \d{2}:\d{2}:\d{2}){0,1}(.\d{1,4}){0,1}$/
